import { builder } from '.';
import * as mutations from './mutations';

const stateGetter = builder.state();

export const gameStore = {
    get state() { return stateGetter(); },

    ...mutations
}
